import React from 'react';
import inflection from 'inflection';
import SelectInput from 'components/select_input';
import Input from 'components/input';
import Form from 'components/form';
import TextArea from 'components/textarea';

import TypeSelector from './type_selector';
import CouponSelector from './coupon_selector';
import PlanSelector from './plan_selector';

class UpdateBillingSubscriptionModal extends React.Component {

  /**
   * A billing subscription tuning dialog.  Takes a billing subscription and hits the Manage::Admin::BillingSubscriptionController#create endpoint.
   *
   * @param props
   * @param props.coupons {Array}
   * @param props.plans {Array}
   * @param props.page
   * @param props.page.id
   * @param props.page.billing_subscription
   * @param props.page.billing_subscription.type
   * @param props.page.billing_subscription.effective_plan
   * @param props.page.billing_subscription.coupon_enabled
   * @param props.page.billing_subscription.plan_enabled
   * @param props.page.billing_subscription.quantity
   * @param props.page.billing_subscription.note
   * @param props.onClose {Function} Function to call when the modal is closed
   */
  constructor (props) {
    super(props);
    this.state = this.props.page.billing_subscription;
  }

  componentWillReceiveProps (newProps) {
    this.setState(newProps.page.billing_subscription);
  }

  disableSubmitButton () {
    let $button = $(this.refs.submitButton);
    $button.text('Updating...');
    $button.addClass('disabled').attr('disabled', true);
  }

  onChange (event) {
    if (event.target.name === 'billing_subscription[type]') {
      let newState = { type: event.target.value };
      // If the the new, selected type is NOT plan enabled,
      // We need to set the current plan to business.
      if (!this.props.types[event.target.value].plan_enabled) {
        // Fine the business plan, and add it to the new state object
        newState.plan = _.find(this.props.plans, { name: 'business' });
      }
      // set the new state
      this.setState(newState);
    } else if (event.target.name === 'billing_subscription[coupon]') {
      this.setState({ coupon: event.target.value });
    } else if (event.target.name === 'billing_subscription[plan_id]') {
      var plan_id = event.target.value;
      // Lookup the plan from the plans array
      this.setState({ plan: _.find(this.props.plans, {id: plan_id}) });
    }
  }

  subscriptionIdInput () {
    if (this.state.type !== 'StripeBillingSubscription') return;
    return (
      <Input name="billing_subscription[subscription_id]"
             label="Subscription ID"
             helpBlockText="If you can't find an appropriate plan and discount, you can create a subscription in Stripe and apply it here." />
    )
  }

  quantityInput () {
    if (this.state.plan.cost !== 100) return;
    return (
      <Input name="billing_subscription[quantity]"
             label="Quantity"
             defaultValue={this.state.quantity}
      />
    )
  }

  render () {
    return (
      <div className="modal hide fade" id={this.props.id}>

        <Form ref="form" for="billing_subscription" action={Routes.page_admin_billing_subscriptions_path(this.props.page)} method="POST" className="form-horizontal" skipPrepend={true} onSubmit={this.disableSubmitButton.bind(this)}>
          <div className="modal-header">
            <a href="#" className="close" data-dismiss="modal">x</a>
            <h4>Update billing subscription</h4>
          </div>

          <div className="modal-body" style={{ maxHeight: 470 }}>

            <TypeSelector types={this.props.types}
                          type={this.state.type}
                          plan={this.state.plan}
                          onChange={this.onChange.bind(this)} />

            <PlanSelector types={this.props.types}
                          type={this.state.type}
                          plan={this.state.plan}
                          plans={this.props.plans}
                          onChange={this.onChange.bind(this)}  />

            {this.quantityInput()}

            <CouponSelector types={this.props.types}
                            type={this.state.type}
                            coupons={this.props.coupons}
                            coupon={this.state.coupon}
                            onChange={this.onChange.bind(this)} />

            {this.subscriptionIdInput()}

            <TextArea name="billing_subscription[note]"
                      label="Note"
                      required={true}
                      defaultValue={this.state.note} />

          </div>

          <div className="modal-footer">
            <button className="cpt-button style-primary" ref="submitButton">Update Subscription</button>
            <a href="#" id={this.props.id} data-dismiss="modal" className="close">Cancel</a>
          </div>
        </Form>

      </div>
    )
  }
}

module.exports = UpdateBillingSubscriptionModal;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/admin/billing_subscriptions/update_billing_subscription_modal.jsx